import { CONNECT_THEME_RENDER_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName.ts';
import { getExperienceTracker } from '@confluence/experience-tracker/entry-points/getExperienceTracker.ts';

export interface ThemeExtension {
	addonKey?: string | null;
	moduleKey?: string | null;
}

type MaybeThemeExtension = ThemeExtension | null | undefined;

type ThemeExperienceTrackerSupportApi = {
	isTrackable(extension: MaybeThemeExtension): boolean;
	start(extension: MaybeThemeExtension): void;
	succeed(): void;
	fail(messageOrError: string | Error): void;
	abort(reason: string): void;
};

const getError = (messageOrError: string | Error): Error => {
	if (messageOrError instanceof Error) {
		return messageOrError;
	}

	return new Error(messageOrError);
};

/**
 * Experience tracker support for the "Connect themes" capability (Group 6 of the
 * @ecosystem Feature Test Migration). Emits the CONNECT_THEME_RENDER_EXPERIENCE
 * experience so a TOME SLO can be defined for remote theme rendering.
 *
 * Mirrors the canonical ConnectCustomContentExperienceTrackerSupport pattern.
 */
export const ThemeExperienceTrackerSupport: ThemeExperienceTrackerSupportApi =
	new (class ThemeExperienceTrackerSupport {
		isTrackable(extension: MaybeThemeExtension): boolean {
			return Boolean(extension?.addonKey) && Boolean(extension?.moduleKey);
		}

		start(extension: MaybeThemeExtension): void {
			getExperienceTracker().start({
				name: CONNECT_THEME_RENDER_EXPERIENCE,
				attributes: {
					addonKey: extension?.addonKey,
					moduleKey: extension?.moduleKey,
				},
			});
		}

		succeed(): void {
			getExperienceTracker().succeed({
				name: CONNECT_THEME_RENDER_EXPERIENCE,
			});
		}

		fail(messageOrError: string | Error): void {
			getExperienceTracker().fail({
				name: CONNECT_THEME_RENDER_EXPERIENCE,
				error: getError(messageOrError),
			});
		}

		abort(reason: string): void {
			getExperienceTracker().abort({
				name: CONNECT_THEME_RENDER_EXPERIENCE,
				reason,
			});
		}
	})();
